import './App.css';
import {
  BrowserRouter as Router,
  Route,
  Routes
} from "react-router-dom";

import Template from './Template';
import Home from './Home';
import BlogPosts from './BlogPosts';
import FirstBlog from './FirstBlog';

import TaggedBlogPosts from './TaggedBlogPosts';
import Logstash from './Logstash';
import GrafanaPlugins from './GrafanaPlugins';
import React from 'react';
import * as Utils from './Utils';
import { useSelector } from 'react-redux';


function App() {
  const blogs = useSelector((state) => state.counter.blogs);
  let sortedBlogs = blogs.sort((a, b) => new Date(...a.postDate.split('/').reverse()) - new Date(...b.postDate.split('/').reverse()));

  return (
    <Router className="App">
      <Routes>
        <Route path="/blogposts" element={<Template content={<BlogPosts />} />} />
        <Route path="/" element={<Template content={<Home />} />} />
        <Route path="/first-blog-post" element={<Template content={<FirstBlog title="First Blog Post" postDate={Utils.formatedDate("2021-12-27")}/>}/>} />
        <Route path="/posts/:tag" element={<Template content={<TaggedBlogPosts />}/>}/>
        <Route path="/logstash-filter-overheads" element={<Template content={<Logstash title="Logstash filter overheads" postDate={Utils.formatedDate("2022-01-08")}/>}/>}/>
      
        <Route path="/grafana-plugin-installation-failure" element={<Template content={<GrafanaPlugins title="Grafana 8.* plugin installation failure" postDate={Utils.formatedDate("2022-01-23")}/>}/>}/>
      
      </Routes>
    </Router>
  );
}
export default App;